var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var WTError = require('../error');

var logger = require('../config/logger');

module.exports = function (_ref) {
  var request = _ref.request,
      findRoute = _ref.findRoute,
      RemoteItem = _ref.RemoteItem;

  /**
   * Retrieve a transfer or board given an id
   * @param   {strint}  id An existing transfer or board id
   * @returns {Promise}    A transfer or board object
   */
  return (
    /*#__PURE__*/
    function () {
      var _find = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                logger.info("Retrieving a ".concat(RemoteItem.name, "."));
                _context.next = 4;
                return request.send(findRoute(id));

              case 4:
                response = _context.sent;
                return _context.abrupt("return", new RemoteItem(response));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                throw new WTError("There was an error when finding the ".concat(RemoteItem.name, "."), _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function find(_x) {
        return _find.apply(this, arguments);
      }

      return find;
    }()
  );
};